import NewProjectPage from './NewProjectPage'
import {fullPageLayoutConfig} from '../layout.helper'

export const NewProjectPageConfig = {
  settings: {
    layout: fullPageLayoutConfig,
  },
  routes: [
    {
      path: '/project/new',
      component: NewProjectPage,
    },
  ],
}



// WEBPACK FOOTER //
// ./src/main/content/projects/NewProjectPageConfig.js